import './_header.scss';
import './_header.twig';

export const name = 'header';

export function disable() {}

const stuckClass = 'header--stuck';

const headerSelector = '.header';
const sentinelSelector = '.header-sentinel';

/**
 * @param {Document | HTMLElement} context
 */
export function enable(context) {
  Array.from(context.querySelectorAll(headerSelector)).forEach((header) => {
    const sentinel = header.parentNode.querySelector(sentinelSelector);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            header.classList.remove(stuckClass);
          } else {
            header.classList.add(stuckClass);
          }
        });
      },
      {
        threshold: 1,
      },
    );

    observer.observe(sentinel);
  });
}

export default enable;
